export interface IPreselectsCount {
    all: number,
    pending: number,
    accepted: number,
    declined: number
}